import { Task } from 'mixs/orders/planner_base';

class TasksToday extends Task {
  taskableData: any;
  init(){
    super.init();
    this.taskableData = this.getTaskableData(this.opts.taskable_id, this.opts.taskable_type);
    this.update();
  }
  location(){
    if(this.taskableData.location_id == null){ return; }
    let locationData = this.getLocationData(this.taskableData.location_id);
    return locationData.name;
  }
  locationName(){
    if(this.taskableData.locations_person_id == null){ return; }
    let personData = this.getLocationsPersonData(this.taskableData.locations_person_id);
    return personData.name;
  }
}

riot.mixin('tasks.today', TasksToday as riot.TagMixin)
